// La Candela: en las reseñas de Judge.me muestra solo el nombre de pila (sin apellidos).
(function () {
  var SELECTOR = '.jdgm-carousel-item__reviewer-name, .jdgm-rev__author';

  function soloNombre(el) {
    if (el.dataset.lcNombre === el.textContent) return;
    var nombre = el.textContent.trim().split(/\s+/)[0] || '';
    if (nombre && nombre.toLowerCase() !== 'anónimo') {
      nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
    }
    el.textContent = nombre;
    el.dataset.lcNombre = nombre;
  }

  function revisar() {
    document.querySelectorAll(SELECTOR).forEach(soloNombre);
  }

  revisar();
  new MutationObserver(revisar).observe(document.body, { childList: true, subtree: true });
})();
